"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaCustom = void 0;
const React = __importStar(require("react"));
const components_core_1 = require("@volkswagen-onehub/components-core");
const text_field_wrapper_1 = require("../text-field-wrapper");
const utils_1 = require("../utils");
const text_helpers_1 = require("../../helpers/text-helpers");
// @todo get from theme
const borderSize = '2px';
const StyledTextArea = components_core_1.styled.textarea `
  ${({ theme, appearance }) => `width: 100%;
  border-radius: 0;
  min-height:${theme.size.static300};
  resize: vertical;
  background: transparent;
  border: 0;
  color: ${(0, utils_1.getColor)({ theme })};
  cursor: ${appearance === text_helpers_1.TextAreaAppearance.Disabled ? 'not-allowed' : ''};
  padding: ${theme.size.static150} 0;
  border-bottom: ${appearance !== text_helpers_1.TextAreaAppearance.ReadOnly &&
    `${borderSize} solid`};
  border-color: ${(0, utils_1.getStatusColor)({ theme })};
  outline: 0;
  font-size:${theme.fonts.copy[200].fontSize};
  line-height: 24px;
  font-family: inherit;
  margin: ${theme.size.static100} 0;
  
  &:focus {
    border-color: ${appearance !== text_helpers_1.TextAreaAppearance.Error
    ? theme.colors.border.active
    : ''};
    outline-style: solid;
    outline-width: 1px;
    outline-color: ${theme.colors.border.default};
    outline-offset: 2px;

    
  }

  ::placeholder {
    color: ${theme.colors.content.primary};
  }
`}
`;
const TextAreaCustom = props => {
    const { label, appearance, onChange, onBlur, onFocus, value, errorText, placeholder, rows = 4, maxLength, required, name, maxRows = 4 } = props;
    const [currentRows, setCurrentRows] = React.useState(rows);
    const textAreaRef = React.useRef(null);
    const handleChange = (event) => {
        var _a;
        const textAreaRows = Math.floor((((_a = textAreaRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0) / 24);
        setCurrentRows(textAreaRows >= maxRows
            ? maxRows
            : textAreaRows <= rows
                ? rows
                : textAreaRows);
        onChange && onChange(event);
    };
    return (React.createElement(text_field_wrapper_1.TextFieldWrapper, { appearance: appearance, label: label, maxLength: maxLength, errorText: errorText, required: required, value: value },
        React.createElement(StyledTextArea, { readOnly: appearance === text_helpers_1.TextAreaAppearance.ReadOnly, disabled: appearance === text_helpers_1.TextAreaAppearance.Disabled, rows: currentRows, name: name, appearance: appearance, onChange: handleChange, onBlur: onBlur, onFocus: onFocus, placeholder: placeholder, value: value, required: required, maxLength: maxLength, className: "textarea-field", ref: textAreaRef })));
};
exports.TextAreaCustom = TextAreaCustom;
